import Constants from 'Constants'

/**
 * Suivi des traitements confiés à un modèle de langage : quels fournisseurs la licence peut
 * interroger, où en est un traitement, et sa relance après un échec. Le lancement appartient à chaque
 * fonctionnalité, dans sa propre mixin.
 */
export default {
	methods: {
		/**
		 * Fournisseurs connectés pour un type de traitement, et celui que l'utilisateur a choisi la
		 * dernière fois.
		 *
		 * @param {String} type
		 * @return {Promise<Object|null>} { providers: [{ key, label, thorough }], last } — thorough : le
		 *                                fournisseur propose un modèle plus attentif pour relancer.
		 */
		getAIProviders: async function(type) {
			const url = Constants.AI_PROVIDERS_URL + "?licence_key=" + Constants.USER_LICENCE_KEY + "&type=" + type

			const result = await this.$request.request_get_api("AITaskMixin::getAIProviders", url)
			if(result) return result.retour
			return null
		},

		/**
		 * Traitements d'un objet, du plus récent au plus ancien.
		 *
		 * @param {String} type
		 * @param {Number} subject_id
		 * @return {Promise<Array|null>}
		 */
		getAITasks: async function(type, subject_id) {
			const url = Constants.AI_TASKS_URL + "?licence_key=" + Constants.USER_LICENCE_KEY + "&type=" + type + "&subject_id=" + subject_id

			const result = await this.$request.request_get_api("AITaskMixin::getAITasks", url)
			if(result) return result.retour
			return null
		},

		/**
		 * Avancement d'un traitement, et son résultat une fois disponible.
		 *
		 * @param {Number} aitask_id
		 * @return {Promise<Object|null>}
		 */
		getAITask: async function(aitask_id) {
			const url = this.constructRoute(Constants.AI_TASK_URL, { aitask_id }) + "?licence_key=" + Constants.USER_LICENCE_KEY

			const result = await this.$request.request_get_api("AITaskMixin::getAITask", url)
			if(result) return result.retour
			return null
		},

		/**
		 * Relance les étapes en échec d'un traitement.
		 *
		 * @param {Number} aitask_id
		 * @return {Promise<Object|null>}
		 */
		retryAITask: async function(aitask_id) {
			const url = this.constructRoute(Constants.AI_TASK_RETRY_URL, { aitask_id }) + "?licence_key=" + Constants.USER_LICENCE_KEY

			const result = await this.$request.request_post_api("AITaskMixin::retryAITask", url, {}, false)
			if(result) return result.retour
			return null
		}
	}
}
